export const PHONE_DISPLAY = "932 543 098";
export const PHONE_TEL = "tel:+351932543098";
export const WHATSAPP_NUMBER = "351932543098";
export const ADDRESS = "Avenida de França, 4050-276 Porto";
export const INSTAGRAM_HANDLE = "@efeito.novo";
export const INSTAGRAM_URL = "https://instagram.com/efeito.novo";
export const SERVICE_AREA = "Grande Porto";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const DEFAULT_WA_MESSAGE =
  "Olá! Gostaria de pedir um orçamento de limpeza profissional.";

export const AREA_CITIES = [
  "Porto",
  "Vila Nova de Gaia",
  "Matosinhos",
  "Maia",
  "Gondomar",
  "Valongo",
  "Vila do Conde",
  "Póvoa de Varzim",
];

export const PRICE_CATEGORIES = [
  {
    id: "sofas",
    icon: "sofa",
    title: "Sofás & Poltronas",
    subtitle: "Higienização profunda, remoção de nódoas e ácaros",
    badge: "Mais Solicitado",
    items: [
      { name: "Sofá 2 lugares", price: "50 €" },
      { name: "Sofá 3 lugares", price: "70 €" },
      { name: "Sofá 4 lugares", price: "90 €" },
      { name: "Poltrona / Cadeira", price: "35 €" },
      { name: "Acréscimo com chaise longue", price: "+ 10 €", addon: true },
    ],
  },
  {
    id: "colchoes",
    icon: "bed",
    title: "Colchões",
    subtitle: "Limpeza frente e verso, tratamento anti-ácaros",
    items: [
      { name: "Colchão solteiro", price: "40 €" },
      { name: "Colchão casal", price: "50 €" },
      { name: "Colchão king size", price: "65 €" },
    ],
    note: "Limpeza feita na frente e no verso do colchão.",
  },
  {
    id: "carpetes",
    icon: "carpet",
    title: "Carpetes",
    subtitle: "Limpeza profunda e renovação de fibras",
    items: [
      { name: "Limpeza profunda", price: "10 €/m²" },
      { name: "Manchas fortes / carpetes muito sujas", price: "12 €/m²" },
    ],
  },
  {
    id: "telhados",
    icon: "roof",
    title: "Telhados",
    subtitle: "Remoção de musgo, algas e proteção hidrofugante",
    items: [
      { name: "Limpeza com musgo / algas", price: "15 €/m²" },
      { name: "Limpeza com hidrofugante", price: "20 €/m²" },
    ],
    note: "Limpeza feita em baixa pressão para não danificar as telhas.",
  },
  {
    id: "terracos",
    icon: "terrace",
    title: "Terraços & Pátios",
    subtitle: "Lavagem de pavimentos, pedra e cerâmica",
    items: [
      { name: "Lavagem simples", price: "4 €/m²" },
      { name: "Sujidade pesada / fungos", price: "8 €/m²" },
      { name: "Tratamento anti-musgo", price: "+ 2 €/m²", addon: true },
    ],
  },
  {
    id: "impermeabilizacao",
    icon: "shield",
    title: "Impermeabilização",
    subtitle: "Proteção invisível contra líquidos e nódoas futuras",
    badge: "Recomendado",
    items: [
      { name: "Poltrona", price: "35 €" },
      { name: "Sofá 2 lugares", price: "55 €" },
      { name: "Sofá 3 lugares", price: "65 €" },
      { name: "Sofá 4 lugares", price: "75 €" },
      { name: "Chaise longue (acréscimo)", price: "+ 10 €", addon: true },
      { name: "Cadeiras estofadas (cada)", price: "23 €" },
    ],
  },
];

export const SERVICE_HIGHLIGHTS = [
  { icon: "sofa", label: "Sofás" },
  { icon: "roof", label: "Telhados" },
  { icon: "terrace", label: "Terraços" },
  { icon: "bed", label: "Colchões" },
  { icon: "sparkles", label: "E Muito Mais" },
];

export const TRUST_POINTS = [
  {
    icon: "shield",
    title: "Qualidade",
    text: "Equipamento profissional de extração e produtos certificados.",
  },
  {
    icon: "heart",
    title: "Confiança",
    text: "Preços transparentes e orçamento gratuito sem compromisso.",
  },
  {
    icon: "sparkles",
    title: "Resultados",
    text: "Estofados, colchões e superfícies com efeito novo outra vez.",
  },
];

export const SIMULATOR_SERVICES = [
  {
    category: "Sofás & Poltronas",
    items: [
      { id: "sofa2", label: "Sofá 2 lugares", price: 50, unit: "unid.", step: 1 },
      { id: "sofa3", label: "Sofá 3 lugares", price: 70, unit: "unid.", step: 1 },
      { id: "sofa4", label: "Sofá 4 lugares", price: 90, unit: "unid.", step: 1 },
      { id: "poltrona", label: "Poltrona / Cadeira", price: 35, unit: "unid.", step: 1 },
      { id: "chaise", label: "Acréscimo chaise longue", price: 10, unit: "unid.", step: 1 },
    ],
  },
  {
    category: "Colchões",
    items: [
      { id: "colchao-solteiro", label: "Colchão solteiro", price: 40, unit: "unid.", step: 1 },
      { id: "colchao-casal", label: "Colchão casal", price: 50, unit: "unid.", step: 1 },
      { id: "colchao-king", label: "Colchão king size", price: 65, unit: "unid.", step: 1 },
    ],
  },
  {
    category: "Impermeabilização",
    items: [
      { id: "imp-poltrona", label: "Poltrona", price: 35, unit: "unid.", step: 1 },
      { id: "imp-sofa2", label: "Sofá 2 lugares", price: 55, unit: "unid.", step: 1 },
      { id: "imp-sofa3", label: "Sofá 3 lugares", price: 65, unit: "unid.", step: 1 },
      { id: "imp-sofa4", label: "Sofá 4 lugares", price: 75, unit: "unid.", step: 1 },
      { id: "imp-cadeira", label: "Cadeira estofada", price: 23, unit: "unid.", step: 1 },
    ],
  },
  {
    category: "Carpetes (por área)",
    items: [
      { id: "carpete-normal", label: "Limpeza profunda", price: 10, unit: "m²", step: 5 },
      { id: "carpete-pesada", label: "Manchas fortes / muito sujas", price: 12, unit: "m²", step: 5 },
    ],
  },
  {
    category: "Telhados (por área)",
    items: [
      { id: "telhado-musgo", label: "Limpeza com musgo / algas", price: 15, unit: "m²", step: 10 },
      { id: "telhado-hidro", label: "Limpeza com hidrofugante", price: 20, unit: "m²", step: 10 },
    ],
  },
  {
    category: "Terraços & Pátios (por área)",
    items: [
      { id: "terraco-simples", label: "Lavagem simples", price: 4, unit: "m²", step: 10 },
      { id: "terraco-pesada", label: "Sujidade pesada / fungos", price: 8, unit: "m²", step: 10 },
      { id: "terraco-antimusgo", label: "Tratamento anti-musgo", price: 2, unit: "m²", step: 10 },
    ],
  },
];

export const TESTIMONIALS = [
  {
    name: "Mariana S.",
    city: "Matosinhos",
    service: "Sofá 3 lugares",
    rating: 5,
    text: "O sofá estava cheio de nódoas dos miúdos e ficou como novo. Serviço rápido, pontual e muito profissional.",
  },
  {
    name: "Jorge P.",
    city: "Vila Nova de Gaia",
    service: "Colchão casal",
    rating: 5,
    text: "Notámos logo a diferença no cheiro e na qualidade do sono. Vale cada euro.",
  },
  {
    name: "Ana R.",
    city: "Maia",
    service: "Telhado",
    rating: 5,
    text: "Telhado cheio de musgo ficou impecável, sem danificar as telhas. Equipa cuidadosa e deixaram tudo limpo.",
  },
  {
    name: "Carlos M.",
    city: "Porto",
    service: "Carpetes",
    rating: 5,
    text: "As carpetes da sala tinham manchas antigas que julgava impossíveis de tirar. Desapareceram.",
  },
  {
    name: "Sofia L.",
    city: "Gondomar",
    service: "Terraço",
    rating: 5,
    text: "O terraço estava verde de humidade e ficou com o aspeto original. Preço exatamente como o orçamento.",
  },
  {
    name: "Rui T.",
    city: "Valongo",
    service: "Impermeabilização",
    rating: 5,
    text: "Impermeabilizaram o sofá novo. Derramei café uma semana depois e o líquido simplesmente não entrou no tecido.",
  },
];

export const GALLERY_ITEMS = [
  {
    id: "sofa",
    label: "Sofá estofado",
    image: "https://images.unsplash.com/photo-1686178827149-6d55c72d81df?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "terraco",
    label: "Terraço",
    image: "https://images.unsplash.com/photo-1783125126994-1096cf16bb85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "carpete",
    label: "Carpete de sala",
    image: "https://images.pexels.com/photos/15743386/pexels-photo-15743386.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
];
